import React from 'react';
import { jsx, ClassNames } from '@emotion/react';

/**
 * This wrapper allows us to also render non-IFL icons.
 */
const IconWrapper = _ref => {
  let {
    children,
    className,
    sx,
    ...props
  } = _ref;
  return jsx(ClassNames, null, _ref2 => {
    var _props$ariaHidden;

    let {
      cx
    } = _ref2;
    return /*#__PURE__*/React.cloneElement(children, {
      "aria-hidden": (_props$ariaHidden = children.props["aria-hidden"]) != null ? _props$ariaHidden : true,
      className: cx(className, children.props.className),
      sx: {
        display: "block",
        flex: "0 0 auto",
        ...sx,
        ...children.props.sx
      },
      ...props
    });
  });
};
IconWrapper.displayName = "IconWrapper";

export { IconWrapper };
